import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

const pendingOrderUpload = '/api/PendingOrdersUpload';

export const getPendingOrderPreview = (data) =>
  authFetch 
    .post(`${pendingOrderUpload}/Preview`, data)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const createPendingOrderBatch = (data) =>
  authFetch
    .post(`${pendingOrderUpload}/Batches`, data)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const previewPendingOrderBatch = (id) =>
  authFetch
    .get(`${pendingOrderUpload}/Batches/${id}/Workbook`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const selectPendingOrderWorksheet = (batchId, data) =>
  authFetch
    .patch(`${pendingOrderUpload}/Batches/${batchId}/Worksheet`, data)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const selectPendingOrderPreset = (batchId, data) =>
  authFetch
    .patch(`${pendingOrderUpload}/Batches/${batchId}/Preset`, data)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const validatePendingOrderPresetAndCommit = (batchId) =>
  authFetch
    .patch(`${pendingOrderUpload}/Batches/${batchId}/ValidateAndCommit`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const getOrdersUpdatesPreview = (batchId) => makeRequest(
  authFetch.get(`${pendingOrderUpload}/Preview/${batchId}`),
);

export const deletePendingOrderBatch = (id) =>
  authFetch
    .delete(`${pendingOrderUpload}/Batches/${id}`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const getPendingOrderProperties = () =>
  authFetch
    .get(`${pendingOrderUpload}/Properties`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const getPendingOrderPresets = (params) =>
  authFetch
    .get(`${pendingOrderUpload}/Presets${getQueryParams(params)}`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const getPendingOrderPresetsSearchProperties = () =>
  authFetch
    .get(`${pendingOrderUpload}/Presets/SearchProperties`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const getPendingOrderPresetDetails = (id) =>
  authFetch
    .get(`${pendingOrderUpload}/Presets/${id}`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const updatePendingOrderPreset = (id, data) =>
  authFetch
    .put(`${pendingOrderUpload}/Presets/${id}`, data)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const deletePendingOrderPreset = (id) =>
  authFetch
    .delete(`${pendingOrderUpload}/Presets/${id}`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const restorePendingOrderPreset = (id) =>
  authFetch
    .patch(`${pendingOrderUpload}/Presets/${id}/Restore`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const insertPendingOrderPreset = (data) =>
  authFetch
    .post(`${pendingOrderUpload}/Presets`, data)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error);
      throw error;
    });

export const importPendingOrders = async (orders) => {
  try {
    const response = await authFetch.post('/api/PendingOrders/Import', orders);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const createPendingOrders = async (orders) => {
  try {
    const response = await authFetch.post('/api/PendingOrders/Create', orders);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getPendingOrders = async (params) => {
  try {
    const response = await authFetch.get(`/api/PendingOrders${getQueryParams(params)}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getPendingOrderSources = async () => {
  try {
    const response = await authFetch.get('/api/PendingOrders/Sources');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const rejectPendingOrders = async (ids) => {
  try {
    const response = await authFetch.post('/api/PendingOrders/Reject', ids);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getPendingOrderQuotes = async (billToId) => {
  try {
    const response = await authFetch.get(`/api/PendingOrders/Quotes?BillToIds=${billToId}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

// data = { pendingOrderIds: [number], quoteId: number }
export const postPendingOrderQuotes = async (data) => {
  try {
    const response = await authFetch.post('/api/PendingOrders/Quotes?BillToIds', data);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getFieldMappings = (params) =>
  makeRequest(authFetch.get(`${pendingOrderUpload}/FieldMappings${getQueryParams(params)}`));

export const getFieldMapping = (id) => makeRequest(authFetch.get(`${pendingOrderUpload}/FieldMappings/${id}`));

export const upsertFieldMapping = (fieldMapping) =>
  makeRequest(authFetch.put(`${pendingOrderUpload}/FieldMappings`, fieldMapping));

export const deleteFieldMapping = (id) => makeRequest(authFetch.delete(`${pendingOrderUpload}/FieldMappings/${id}`));

export const restoreFieldMapping = (id) =>
  makeRequest(authFetch.patch(`${pendingOrderUpload}/FieldMappings/${id}/restore`));

export const getFieldMappingAudits = (id, params) =>
  makeRequest(authFetch.get(`${pendingOrderUpload}/FieldMappings/${id}/Audits${getQueryParams(params)}`));

export const getFieldMappingAuditProperties = (id) =>
  makeRequest(authFetch.get(`${pendingOrderUpload}/FieldMappings/${id}/Audits/Properties`));

export const getFieldMappingAuditUsers = (id) =>
  makeRequest(authFetch.get(`${pendingOrderUpload}/FieldMappings/${id}/Audits/Users`));

export const putPendingOrder = (pendingOrder) => makeRequest(authFetch.put(`/api/PendingOrders/`, pendingOrder));
export const putPendingOrders = (pendingOrders) => makeRequest(authFetch.put(`/api/PendingOrders/bulk`, pendingOrders));
export const restorePendingOrder = (id) => makeRequest(authFetch.patch(`/api/PendingOrders/${id}/Restore`));
export const deletePendingOrder = (id) => makeRequest(authFetch.delete(`/api/PendingOrders/${id}`));

export const createOrdersFromPendingOrders = (ids) =>
    makeRequest(authFetch.post(`/api/PendingOrders/CreateOrders`, ids));

export const deleteMultiplePendingOrders = (ids) =>
    makeRequest(authFetch.delete(`/api/PendingOrders/`, { data: ids }));

export const getPendingOrdersSearchProperties = () => makeRequest(authFetch.get(`/api/PendingOrders/SearchProperties`));
export const updateQuoteLanes = (request) => makeRequest(authFetch.patch(`/api/PendingOrdersUpload/updateQuoteLanes`, request));

export const getPendingOrderStatuses = () => makeRequest(authFetch.get(`/api/PendingOrders/Statuses`));

export const getPendingOrdersLookupByCreatedBy = () => makeRequest(authFetch.get(`/api/PendingOrders/Lookup/CreatedBy`));

// Failed Mappings
const FAILED_MAPPINGS_PATH = 'api/PendingOrderMappings';

export const getFailedMappings = (params) => makeRequest(
  authFetch.get(`${FAILED_MAPPINGS_PATH}${getQueryParams(params)}`),
);

export const getFailedMappingById = (failedMappingId) => makeRequest(
  authFetch.get(`${FAILED_MAPPINGS_PATH}/${failedMappingId}`),
);

export const deleteFailedMapping = (failedMappingId) => makeRequest(
  authFetch.delete(`${FAILED_MAPPINGS_PATH}/${failedMappingId}`),
);

export const restoreFailedMapping = (failedMappingId) => makeRequest(
  authFetch.patch(`${FAILED_MAPPINGS_PATH}/${failedMappingId}/restore`),
);

export const setFailedMappingPreset = (failedMappingId, preset) => makeRequest(
  authFetch.patch(`${FAILED_MAPPINGS_PATH}/${failedMappingId}/preset`, preset),
);

export const validateAndCommitFailedMapping = (failedMappingId) => makeRequest(
  authFetch.patch(`${FAILED_MAPPINGS_PATH}/${failedMappingId}/ValidateAndCommit`),
);

export const getFailedMappingAudits = (failedMappingId, params) => makeRequest(
  authFetch.get(`${FAILED_MAPPINGS_PATH}/${failedMappingId}/Audits${getQueryParams(params)}`),
);

export const getFailedMappingAuditProperties = (failedMappingId) => makeRequest(
  authFetch.get(`${FAILED_MAPPINGS_PATH}/${failedMappingId}/Audits/Properties`),
);

export const getFailedMappingAuditUsers = (failedMappingId) => makeRequest(
  authFetch.get(`${FAILED_MAPPINGS_PATH}/${failedMappingId}/Audits/Users`),
);

export const mergePendingOrderIntoOrder = (pendingOrderId, proNumber) => makeRequest(
  authFetch.patch(`api/PendingOrders/${pendingOrderId}/Merge/${proNumber}`),
);

export const bulkUpdatePendingOrders = (changes) => makeRequest(authFetch.patch('/api/PendingOrders/BulkUpdate', changes));
export const getPendingOrderBulkUpdateProperties = () => makeRequest(authFetch.get('/api/PendingOrders/BulkUpdate/Properties'));
